import React from 'react'
import { getDangerousHtml } from '../../helpers/components';
import  './PromotionalMessaging.css';

const PromotionalMessaging = ({ children }) => (
  <div className="promotional_msg" dangerouslySetInnerHTML={getDangerousHtml(children)} />
);

export default PromotionalMessaging;


// WEBPACK FOOTER //
// ./src/components/PromotionalMessaging/index.js